import React from 'react';
import { useStore } from './useStore';
import { Navigate, useNavigate } from 'react-router-dom';
import { ADMIN_ROUTES, ROUTES, SCREEN_TYPE } from '@shared/configs/constants';

interface WithAuthenticationNotPermittedProps {
    screenType: string
}

export default function withAuthenticationNotPermitted<P extends object>(
    WrappedComponent: React.ComponentType<P>
) {
    const WithAuthenticationNotPermitted = (props: P & WithAuthenticationNotPermittedProps): React.ReactElement => {
        // store
        const { screenType } = props;

        const {
            authStore: { token },
            modalStore: { showAlertModal }
        } = useStore();

        const navigate = useNavigate();

        if (token) {
            showAlertModal({
                id: 'model-connected-session',
                content: <div>前回のセッションからログアウトしてください。</div>,
                type: 'success',
                footerClassName: 'sm:justify-center',
                cancelButtonClassName: 'hidden',
                onSave: () => {
                    if (screenType === SCREEN_TYPE.GA) {
                        navigate(ADMIN_ROUTES.profile.href);
                    } else {
                        navigate(ROUTES.home.href);
                    }
                },
                showCloseIcon: false
            });
            return <div></div>;
        }
        return <WrappedComponent {...(props as P)} />;
    };

    return WithAuthenticationNotPermitted;
}
